module.exports = __webpack_public_path__ + "img/20190716162724829.1ad45c16.png";